import React from "react";
import { controlPropTypes } from "../formhelpers";

export default class Textarea extends React.Component {

    constructor(props) {
        super(props);
        this.inputRef = props._ref || React.createRef();
        /* Some controls will require a local state so editing can take place
         * before the final value is actually committed.
         */
        this.state = {
            value: this.convertValueToString(props.value)
        };
        this.hasChanges = false; // this is used so onBlur only commits when changes have been made.
        this.hasFocus = false; // only commit change when control has focus.
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    convertStringToValue(value) {
        if(value === "") {
            return null;
        }
        return value;
    }

    convertValueToString(value) {
        if(value === undefined || value === null) {
            return "";
        }
        return value;
    }

    onKeyDown(e) {
        const { descriptor, onKeyDown } = this.props;
        const newValue = this.convertStringToValue(e.target.value);
        onKeyDown && onKeyDown(e, descriptor, newValue);
    }

    onClick(e) {
        const { descriptor, onClick } = this.props;
        onClick && onClick(e, descriptor, this.convertStringToValue(e.target.value));
    }

    onFocus(e) {
        const { descriptor, onFocus } = this.props;
        onFocus && onFocus(e, descriptor, this.convertStringToValue(e.target.value));
        this.hasFocus = true;
    }

    onBlur(e) {
        const { descriptor, onBlur, value, enabled, onCommitChange } = this.props;
        if(!this.hasFocus) {
            // control does not have focus.
            return;
        }
        const newValue = this.convertStringToValue(e.target.value);
        if(newValue !== value) {
            // commit the value change
            enabled && onCommitChange(descriptor, newValue);
        }
        this.hasChanges = false;
        enabled && onBlur && onBlur(e, descriptor, newValue);
        this.hasFocus = false;
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        // if the control has focus and has changes then don't change the local state.
        // the user is most editing a while records are updating in the background.
        if(this.hasChanges && this.hasFocus) return;

        /* Make sure the local state stays in sync with the passed in props.
         */
        const nextValue = this.convertValueToString(newProps.value);
        if(this.state.value !== nextValue || this.inputRef.current.value !== nextValue) {
            this.setState({value: nextValue});
            this.hasChanges = false;
        }
    }

    onChange(e) {
        const { descriptor, onChange } = this.props;
        const value = this.convertStringToValue(e.target.value);
        this.setState({value: this.convertValueToString(value)});
        this.hasChanges = true;
        onChange && onChange(e, descriptor, value);
    }

    render() {
        const { className, descriptor, placeholder, enabled, style } = this.props;

        const value = this.state.value || "";
        const classname = (className || "form-control") + " focusable";

        return (<textarea
            ref={this.inputRef}
            className={classname}
            onClick={this.onClick}
            onChange={this.onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onKeyDown={this.onKeyDown}
            value={value}
            placeholder={placeholder ? descriptor.label : ""}
            disabled={!enabled}
            style={style}
        />);

    }
}

Textarea.propTypes = controlPropTypes();



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/Textarea.js